// deviceInfo.js
export async function getDeviceInfo() {
  const ua = navigator.userAgent || "";
  const uaData = navigator.userAgentData;

  // Base mobile check
  const uaMobile = /Mobi|Android|iPhone|iPod/i.test(ua);
  const uaTablet =
    /iPad|Tablet|Nexus 7|Nexus 9|Nexus 10|SM-T|Tab|Kindle|Silk|PlayBook/i.test(ua);

  // iPadOS 13+ sometimes reports "Macintosh"
  const looksLikeIPadOS = /Macintosh/.test(ua) && (navigator.maxTouchPoints || 0) > 1;

  const mobile = uaData?.mobile ?? (uaMobile || looksLikeIPadOS);
  const tablet = uaData ? false : (uaTablet || looksLikeIPadOS && !uaMobile);

  const category = mobile ? "mobile" : tablet ? "tablet" : "desktop";

  // Optional high-entropy details (Chromium). Safe to try/catch.
  let hi = {};
  try {
    if (uaData?.getHighEntropyValues) {
      hi = await uaData.getHighEntropyValues([
        "model",
        "platform",
        "platformVersion",
        "architecture",
        "bitness",
        "fullVersionList",
      ]);
    }
  } catch {}

  return {
    category,                 // "mobile" | "tablet" | "desktop"
    mobile,
    tablet,
    touchPoints: navigator.maxTouchPoints || 0,
    platform: uaData?.platform || navigator.platform || null,
    model: hi.model || null,
    osVersion: hi.platformVersion || null,
    browserBrands: hi.fullVersionList || uaData?.brands || null,
    userAgent: ua,            // include only if your data team wants it
    screen: {
      width: window.screen.width,
      height: window.screen.height,
    }
  };
}